export default "__VITE_ASSET__DvyEGLow__"